import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type {
  DashboardAggregate,
  DashboardLayoutData,
  DashboardRole,
  LayoutItem,
  WidgetKey,
  WidgetsCatalog,
} from '@/types/dashboard'

interface ApiWrapper<T> {
  success: boolean
  message?: string
  data: T
}

export const dashboardApi = {
  widgets: async (role?: DashboardRole): Promise<WidgetsCatalog> => {
    const response = await apiClient.get<ApiWrapper<WidgetsCatalog>>(
      API_ENDPOINTS.DASHBOARD.WIDGETS,
      { params: role ? { role } : undefined },
    )
    return response.data.data
  },

  layout: async (role?: DashboardRole): Promise<DashboardLayoutData> => {
    const response = await apiClient.get<ApiWrapper<DashboardLayoutData>>(
      API_ENDPOINTS.DASHBOARD.LAYOUT,
      { params: role ? { role } : undefined },
    )
    return response.data.data
  },

  saveLayout: async (role: DashboardRole, layout: LayoutItem[]): Promise<DashboardLayoutData> => {
    const response = await apiClient.put<ApiWrapper<DashboardLayoutData>>(
      API_ENDPOINTS.DASHBOARD.LAYOUT,
      { role, layout },
    )
    return response.data.data
  },

  resetLayout: async (role: DashboardRole): Promise<DashboardLayoutData> => {
    const response = await apiClient.post<ApiWrapper<DashboardLayoutData>>(
      API_ENDPOINTS.DASHBOARD.LAYOUT_RESET,
      undefined,
      { params: { role } },
    )
    return response.data.data
  },

  aggregate: async (role: DashboardRole, widgets?: WidgetKey[]): Promise<DashboardAggregate> => {
    const endpoint =
      role === 'teacher' ? API_ENDPOINTS.DASHBOARD.TEACHER : API_ENDPOINTS.DASHBOARD.STUDENT
    const response = await apiClient.get<ApiWrapper<DashboardAggregate>>(endpoint, {
      params: widgets && widgets.length > 0 ? { widgets: widgets.join(',') } : undefined,
    })
    return response.data.data
  },
}
